import React from 'react';
import { useTranslation } from 'react-i18next';
import MainButton from '../../../components/buttons/main';
import { useCurrency } from '../../../hooks/useCurrency';

const CheckoutHeader = ({ bill, onEditSplit, onOpenBill }) => {
  const { t } = useTranslation();
  const { currencySymbol } = useCurrency();

  if (bill.type === 'order') {
    return null;
  }

  const subtotal = bill.subtotal || 0;

  return (
    <div className="overflow-hidden sm:px-3 -mx-5 pb-6">
      <div className="box-shadow2 pb-5 px-5 bg-white rounded-b-3xl shadow-[0_3px_17px_rgba(17,24,39,0.1)]">
        <div className="flex flex-row justify-between items-center mb-5">
          <p className="font-primaryMedium text-2xl text-primary">{t('checkout.youArePaying')}</p>
          <p className="font-primaryMedium text-2xl text-primary">
            {subtotal.toFixed(2)} {currencySymbol}
          </p>
        </div>
        <div className="flex justify-center">
          <div className="max-w-xs w-full">
            {bill.type === 'split' && (
              <>
                <MainButton text={t('buttons.editSplit')} outline onClick={onEditSplit} />
                <div className="mb-3" />
              </>
            )}
            {(bill.type === 'split' || bill.type === 'full') && (
              <MainButton text={t('buttons.viewFullBill')} outline onClick={onOpenBill} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutHeader;
